import { useLocalStorage, StorageSerializers, get } from "@vueuse/core"


export const useProjectStore = defineStore("projects", () => {
  // Persist selected project to localStorage (JSON-serialized)
  const selectedProject = useLocalStorage("forestlink:selectedProject", null, {
    serializer: StorageSerializers.object,
  })

  const getProjects = async () => {
    try {
      return await $fetch(`/api/admin/projects`, {
        headers: { "Content-type": "application/json" },
        method: "GET",
      })
    } catch (error) {
      console.error("Failed to fetch projects:", error)
      return { error: true, ...error.data.data }
    }
  }

  const getUserProjects = async () => {
    try {
      return await $fetch(`/api/projects`, {
        headers: { "Content-type": "application/json" },
        method: "GET",
      })
    } catch (error) {
      console.error("Failed to fetch user projects:", error)
      return { error: true, ...error.data.data }
    }
  }


  const updateProject = async (data) => {
    const body = toRaw(data.value)
    console.log(body)
    try {
      return await $fetch(`/api/admin/projects`, {
        headers: { "Content-type": "application/json" },
        method: "PUT",
        body,
      })
    } catch (error) {
      console.error("Failed to update project:", error)
      return { error: true, ...error.data.data }
    }
  }

  const createProject = async (body) => {
    try {
      const response = await $fetch(`/api/admin/projects`, {
        headers: { "Content-type": "application/json" },
        method: "POST",
        body,
      })
      return response
    } catch (error) {
      console.error("Failed to create project:", error)
      return { error: true, ...error.data.data }
    }
  }

  const deleteProject = async (data) => {
    const { id } = data
    const body = toRaw(data)
    try {
      const response = await $fetch(`/api/admin/projects/${id}`, {
        headers: { "Content-type": "application/json" },
        method: "DELETE",
        body,
      })
      return response
    } catch (error) {
      console.error("Failed to delete project:", error)
      return { error: true, ...error.data.data }
    }
  }

  const getProjectById = async (id) => {
    // RFUK ADMIN's only
    try {
      const response = await $fetch(`/api/admin/projects/${id}`, {
        headers: { "Content-type": "application/json" },
        method: "GET",
      })
      return response.data
    } catch (error) {
      console.error("Failed to fetch project by id:", error)
      return { error: true, ...error.data.data }
    }
  }

  const getUserProjectById = async (projectId) => {
    try {
      const response = await $fetch(`/api/project/${projectId}`, {
        headers: { "Content-type": "application/json" },
        method: "GET",
      })
      return response
    } catch (error) {
      console.error("Failed to fetch project info by id:", error)
      return { error: true, ...error.data.data }
    }
  }


  const setSelectedProject = (project) => {
    if (!project) {
      selectedProject.value = null
      return
    }

    selectedProject.value = {
      id: project.id,
      name: project.name,
      defaultLanguage: project.defaultLanguage,
    }
  }


  const getSelectedProject = () => {
    return selectedProject.value
  }

  const clearSelectedProject = () => {
    selectedProject.value = null
  }

  // Add a method to update project geometry
  const updateProjectGeometry = async (projectId, geometry) => {
    try {
      const response = await $fetch(
        `/api/admin/projects/geometry/${projectId}`,
        {
          headers: { "Content-type": "application/json" },
          method: "PUT",
          body: geometry,
        }
      )
      return response
    } catch (error) {
      console.error("Failed to update project geometry:", error)
      return { error: true, ...error.data?.data }
    }
  }

  return {
    getProjects,
    getUserProjects,
    updateProject,
    getProjectById,
    getUserProjectById,
    createProject,
    deleteProject,
    selectedProject,
    setSelectedProject,
    getSelectedProject,
    clearSelectedProject,
    updateProjectGeometry, // <-- add here
  }
})
